import { Component } from '@angular/core';

@Component({
    selector: 'maintenance',
    templateUrl: './maintenance.html'
})
export class MaintenanceComponent {

}
